import Tooltip from "../../utils/Tooltip";

const Input = ({ text, type, list, tooltip, helperText, ...rest }) => {
    const renderElement = () => {
        // Common classes for text-based inputs
        const standardClasses = `bg-gray-50 focus:outline-none focus:shadow-input block w-full p-3 text-sm text-gray-900 border border-gray-400 rounded-lg`;

        switch (type) {
            case "textarea":
                return (
                    <textarea
                        spellCheck={false}
                        {...rest}
                        className={standardClasses}
                    />
                );

            case "select":
            case "select-gender":
                return (
                    <select className={standardClasses} {...rest}>
                        <option value="">{`Select ${text}`}</option>
                        {list.map((element) => (
                            <option key={element.id} value={type === "select" ? element.id : element.value}>
                                {element.name}
                            </option>
                        ))}
                    </select>
                );

            case "checkbox":
                return (
                    <div className="flex items-center h-11"> {/* Height matched to p-3 inputs */}
                        <input
                            type="checkbox"
                            {...rest}
                            className="w-5 h-5 text-blue-600 bg-gray-50 border-gray-400 rounded focus:ring-blue-500 focus:ring-2"
                        />
                        <label className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-400">
                            {text} {rest.required && <span className="text-red-500">*</span>}
                        </label>
                        {tooltip && <div className="ml-2"><Tooltip text={tooltip} /></div>}
                    </div>
                );

            default:
                return (
                    <input
                        type={type || "text"}
                        {...rest}
                        className={standardClasses}
                    />
                );
        }
    };

    // If it's a checkbox, we render the element directly without the top-level label
    if (type === "checkbox") {
        return (
            <div className="flex-1 mb-6">
                {renderElement()}
                {helperText && <p className="m-2 text-xs text-red-400">{helperText}</p>}
            </div>
        );
    }

    return (
        <div className="flex-1 mb-6">
            <label className="dark:text-gray-400 block mb-2 text-sm font-medium text-gray-900">
                <span className="group relative flex items-center gap-2">
                    <span>{text}</span>
                    {rest.required && <span className="text-base leading-none text-red-500">*</span>}
                    {tooltip && <Tooltip text={tooltip} />}
                </span>
            </label>
            {renderElement()}
            {helperText && (
                <p className="m-2 text-xs leading-tight text-red-400">
                    {helperText}
                </p>
            )}
        </div>
    );
};

export default Input;